import { useRdPageLockStatus, useQuestionSections } from '@neo.tax/rd/hooks';
import { RedirectState } from '@neo.tax/shared';

export const useCompanyInfoRedirect = (): RedirectState => {
  const { loading: loadingQuestionSections } = useQuestionSections();
  const { loading: loadingPageLockStatus } = useRdPageLockStatus();
  return {
    isLoading: loadingQuestionSections || loadingPageLockStatus,
  };
};
